import { format, isValid } from 'date-fns';

import { dateFormat } from 'constants/formats';
import { TranslateFn } from 'hooks/useTranslate';
import { formatNumber } from 'utils/formats';

import { PartnerExtraField } from 'types/Partner';

const EMPTY_VALUE = '-';

export const formatPartnerExtraFieldValue = (
  field: PartnerExtraField,
  t: TranslateFn
): string => {
  const { fieldType, value } = field;

  if (value === null || value === undefined || value === '') {
    return EMPTY_VALUE;
  }

  switch (fieldType) {
    case 'STRING':
      return String(value);

    case 'NUMBER':
      if (typeof value !== 'number' || Number.isNaN(value)) {
        return EMPTY_VALUE;
      }
      return formatNumber(value) || EMPTY_VALUE;

    case 'DATE': {
      let dateValue: Date;

      if (value instanceof Date) {
        dateValue = value;
      } else if (typeof value === 'string' || typeof value === 'number') {
        dateValue = new Date(value);
      } else {
        return EMPTY_VALUE;
      }

      if (!isValid(dateValue)) {
        return EMPTY_VALUE;
      }
      return format(dateValue, dateFormat);
    }

    case 'BOOLEAN':
      if (typeof value !== 'boolean') {
        return EMPTY_VALUE;
      }
      return value ? t('Yes') : t('Nope');

    default:
      return EMPTY_VALUE;
  }
};
